import { toast } from 'react-toastify';
import AsnAPI, { CartonApiZpl } from '../../../Api/asn';

const generatePoLineCartonZPL = async (
  userId: string,
  lineId: string,
  unitCount: number,
  numLabels: number,
  mix: boolean,
) => {
  try {
    const response = (await AsnAPI.getPoLineLabelCartonData(
      userId,
      lineId,
      numLabels > 0 ? numLabels : undefined,
      mix,
      unitCount,
    )) as CartonApiZpl;
    if (!response) throw new Error('failed to get the poLine data');

    return {
      zpl: response.zpl,
      request_id: response.request_id,
    };
  } catch (error: unknown) {
    console.error('Failed to get the purchase order line data', error);
    toast('Failed to get the purchase order line data', {
      type: 'error',
    });
    return null;
  }
};

export { generatePoLineCartonZPL };
